/* eslint-disable complexity */
import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
	faLock,
	faUser,
	faSignIn,
	faPhone,
	faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';

import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import Visibility from '@material-ui/icons/Visibility';
import InputAdornment from '@material-ui/core/InputAdornment';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Input from '@material-ui/core/Input';

import './styles.scss';
import {updateObject} from '../../utils/reducerUtils';
import Logo from '../../assets/dysmate-logo-hvit-small.png';
import PinCode from './pinCode';
import addAdminCustom from '../../api/addAdminCustom';
import verifyAdminCustom from '../../api/verifyAdminCustom';
import initResetPassword from '../../api/initResetPassword';
import resetPassword from '../../api/resetPassword';
import checktokenValidity from '../../api/checktokenValidity';

import changeMethodCustom from '../../api/changeMethodCustom';
import strings from '../../utils/strings';

import queryString from 'query-string';
import AlertBox from '../../components/Alert';

const parsedSearch = queryString.parse(window.location.search);
const testKey = parsedSearch.key;
const resetFlag = parsedSearch.passwordResetToken || false;
const PIN_LEN = 6;
class EmailPasswordLogin extends React.Component {
	constructor(props) {
		super(props);

		const regTokenChange =
			props.regTokenChange ?? parsedSearch.regTokenChange;

		this.state = {
			invalidEmail: false,
			emailTouched: false,

			strengthExhibitor: null,
			isStrongPassword: false,
			unmatchedPassword: false,
			hasSendVerification: false,
			isResetingPsw: false,
			resendEmail: null,
			emailError: null,
			hasResetToken: resetFlag || null,
			flowStatus: null,
			pswError: null,
			showPassword: false,
			isTokenValid: true,
			linkTimedOut: false,
			loading: false,
			isForgetPasswordClicked: false,
			regTokenChange: regTokenChange ?? null,
			isResendButtonDisabled: true,
			resendCountDown: 10,
			testAdmin: {
				firstName: '',
				lastName: '',
				email: '',
				regId: testKey ?? null,
				regTokenChange: regTokenChange ?? null,
				phone: '',
				psw: '',
				pin: '',
			},
			passwordChecks: {
				length: false,
				upper: false,
				digit: false,
				special: false,
			},
			passwordValid: false,

			confirmPsw: '',
			showAlert: false,
			error: null,
			success: null,
			message: '',
		};

		this.handleUpdate = this.handleUpdate.bind(this);
		this.handleUpdateTestAdminEvent =
			this.handleUpdateTestAdminEvent.bind(this);
		this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
		this.startCountdown = this.startCountdown.bind(this);
		this.handleResendClick = this.handleResendClick.bind(this);
	}

	componentDidMount() {
		if (resetFlag) {
			checktokenValidity(resetFlag).then((res) => {
				if (res?.error === 'Not found') {
					this.setState({
						flowStatus: 'link does not exit',
						linkTimedOut: true,
						isTokenValid: false,
					});
					this.redirectTimeout = setTimeout(() => {
						window.top.location.href = `/login`;
					}, 4000);
				} else if (res?.status === 408) {
					this.setState({
						flowStatus: 'link expired',
						linkTimedOut: true,
						isTokenValid: false,
					});
					this.redirectTimeout = setTimeout(() => {
						window.top.location.href = `/login`;
					}, 4000);
				}
			});
		}
	}

	componentWillUnmount() {
		if (this.interval) clearInterval(this.interval);
		if (this.redirectTimeout) clearTimeout(this.redirectTimeout);
		if (this.alertTimeout) clearTimeout(this.alertTimeout);
	}

	setRequiredMsg = (e, msg = 'Bitte füllen Sie dieses Feld aus.') => {
		e.target.setCustomValidity(msg);
	};

	clearValidity = (e) => e.target.setCustomValidity('');
	setEmailMsg = (e) =>
		e.target.setCustomValidity(
			'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
		);
	setPasswordPatternMsg = (e) =>
		e.target.setCustomValidity(
			'Mindestens 8 Zeichen mit 1 Großbuchstaben, 1 Zahl und 1 Sonderzeichen.'
		);
	setPasswordMatchMsg = (e) =>
		e.target.setCustomValidity('Passwörter stimmen nicht überein.');
	handlePhoneBeforeInput = (e) => {
		if (e.data && /\D/.test(e.data)) e.preventDefault();
	};

	handlePhonePaste = (e) => {
		const text = (e.clipboardData || window.clipboardData).getData('text');
		if (/\D/.test(text)) {
			e.preventDefault();
			const cleaned = text.replace(/\D+/g, '').slice(0, 11);
			this.setState({phone: (this.state.phone || '') + cleaned});
		}
	};

	handlePhoneChange = (e) => {
		const cleaned = e.target.value.replace(/\D+/g, '').slice(0, 11);
		this.setState({phone: cleaned});
	};
	updatePasswordChecks = (value) => {
		const checks = {
			length: value.length >= 8,
			upper: /[A-Z]/.test(value),
			digit: /\d/.test(value),
			special: /[\W_]/.test(value),
		};
		const all =
			checks.length && checks.upper && checks.digit && checks.special;
		this.setState({passwordChecks: checks, passwordValid: all});
		return {checks, all};
	};

	handlePinChange = (ev) => {
		let v = (ev.target.value || '').replace(/[^a-zA-Z0-9]/g, ''); // allowing both cases

		if (v.length > PIN_LEN) v = v.slice(0, PIN_LEN);

		ev.target.value = v;
		this.handleUpdateTestAdminEvent(ev);
	};

	setRequiredMsg = (e, msg = 'Bitte füllen Sie dieses Feld aus.') => {
		e.target.setCustomValidity(msg);
	};
	clearValidity = (e) => {
		e.target.setCustomValidity('');
	};
	setEmailMsg = (e) => {
		e.target.setCustomValidity(
			'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
		);
	};
	setPasswordPatternMsg = (e) => {
		e.target.setCustomValidity(
			'Mindestens 8 Zeichen, mit mindestens 1 Großbuchstaben, 1 Zahl und 1 Sonderzeichen.'
		);
	};
	setPasswordMatchMsg = (e) => {
		e.target.setCustomValidity('Passwörter stimmen nicht überein.');
	};
	startCountdown = () => {
		if (this.interval) clearInterval(this.interval);
		this.interval = setInterval(() => {
			this.setState((prev) => {
				if (prev.resendCountDown <= 1) {
					clearInterval(this.interval);
					return {isResendButtonDisabled: false, resendCountDown: 0};
				}
				return {resendCountDown: prev.resendCountDown - 1};
			});
		}, 1000);
	};

	handleResendClick = () => {
		this.setState({isResendButtonDisabled: true, resendCountDown: 10});
		this.startCountdown();
		this.sendResetLink(this.state.testAdmin.email);
	};

	handleClickShowPassword() {
		this.setState((s) => ({showPassword: !s.showPassword}));
	}

	handleMouseDownPassword(event) {
		event.preventDefault();
	}

	validateEmail = (event) => {
		this.handleUpdateTestAdminEvent(event);
		const value = event.target.value || '';
		const emailOk = !value || /^\S+@\S+\.\S+$/.test(value);
		this.setState({invalidEmail: !emailOk});
	};

	validatePassword = (event) => {
		const value = event.target.value || '';

		const {all} = this.updatePasswordChecks(value);

		if (!all) this.setPasswordPatternMsg(event);
		else this.clearValidity(event);

		if (!value) {
			this.setState({strengthExhibitor: null});
		} else if (all) {
			this.setState({strengthExhibitor: 'lit-strength-Exhibitor-green'});
		} else if (
			/^(?=.*[a-z])(?=.*[A-Z])|(?=.*[a-z])(?=.*\d)|(?=.*[A-Z])(?=.*\d)/.test(
				value
			)
		) {
			this.setState({strengthExhibitor: 'lit-strength-Exhibitor-orange'});
		} else {
			this.setState({strengthExhibitor: 'lit-strength-Exhibitor-red'});
		}
		this.handleUpdateTestAdminEvent(event);

		if (this.state.confirmPsw) {
			const fakeEvt = {
				target: {
					value: this.state.confirmPsw,
					setCustomValidity: () => {},
				},
			};
			this.validateConfirm(fakeEvt);
		}
	};

	validateConfirm = (e) => {
		const confirm = e.target.value || '';
		const pwd = this.state.testAdmin.psw || '';
		if (!this.state.passwordValid) {
			this.clearValidity(e);
			this.setState({confirmPsw: confirm, unmatchedPassword: false});
			return;
		}

		const mismatch = pwd !== confirm;
		if (mismatch) this.setPasswordMatchMsg(e);
		else this.clearValidity(e);
		this.setState({confirmPsw: confirm, unmatchedPassword: mismatch});
	};

	validateMatchingPasswords = () => {
		const password = this.state.testAdmin.psw || '';
		const confirmPassword = this.state.confirmPsw || '';
		const mismatch = password !== confirmPassword;
		this.setState({unmatchedPassword: mismatch});

		const el = document.getElementById('txtConfirmPassword');
		if (el) el.setCustomValidity(mismatch ? 'Passwords do not match' : '');
	};

	handleUpdateTestAdminEvent(event) {
		const {name, value} = event.target;
		if (name === 'confirm-psw') {
			this.validateConfirm(event);
			return;
		}
		this.handleUpdate(name, value);
		if (name === 'psw') {
			if (this.state.confirmPsw) this.validateMatchingPasswords();
		}
	}

	handleUpdate(key, value) {
		const {testAdmin} = this.state;
		this.setState({
			testAdmin: updateObject(testAdmin, {[key]: value}),
		});
	}

	addAdminViaCustomMethod() {
		addAdminCustom(testKey).then((res) => {
			this.setState({loading: false});
			if (res?.ok) {
				this.setState({hasSendVerification: true});
			}
		});
	}

	verifyAdminRegistration = () => {
		const {testAdmin} = this.state;

		const payload = {
			regId: testAdmin.regId,
			pin: testAdmin.pin,
			psw: testAdmin.psw,
			firstName: testAdmin.firstName,
			lastName: testAdmin.lastName,
			email: testAdmin.email,
		};

		return verifyAdminCustom(payload)
			.then((response) => {
				// success path
				if (response?.action === 'auth' && response?.result === 'OK') {
					localStorage.setItem('authtoken', response.authToken);
					window.top.location.href = `/my-tests`;
					return true;
				}

				this.setState({
					pinError: true,
					pinMessage: 'Unbekannter Fehler.',
				});
			})
			.catch((err) => {
				let pinMessage = 'Ein Fehler ist aufgetreten.';
				if (
					err?.status === 401 &&
					/Invalid regId or pin/i.test(err.error)
				) {
					pinMessage = 'Falscher PIN. Bitte erneut versuchen.';
				} else if (err?.status === 404) {
					pinMessage = err.error;
				} else if (err?.status === 410) {
					pinMessage = 'Bestätigungslink ist abgelaufen.';
				} else if (typeof err?.error === 'string') {
					pinMessage = err.error;
				}

				this.setState({pinError: true, pinMessage});
				return false;
			})
			.finally(() => this.setState({loading: false}));
	};

	sendResetLink(email) {
		initResetPassword(email).then((resetResponse) => {
			this.setState({loading: false});

			if (!resetResponse?.error) {
				this.setState({
					isResetingPsw: true,
					isForgetPasswordClicked: false,
					flowStatus: strings.resetpswlinksent,
					resendEmail: this.state.testAdmin.email,
				});
				this.startCountdown();
			} else {
				this.setState({
					showAlert: true,
					error: true,
					message: resetResponse.error,
				});
				this.alertTimeout = setTimeout(
					() => this.setState({showAlert: false}),
					3000
				);
			}
		});
	}

	allowOperation() {
		const {testAdmin} = this.state;

		const payload = {
			regId: testAdmin.regId,
			pin: testAdmin.pin,
			psw: testAdmin.psw,
			firstName: testAdmin.firstName,
			lastName: testAdmin.lastName,
			email: testAdmin.email,
		};
		if (!testKey && !resetFlag) {
			return verifyAdminCustom(payload)
				.then((response) => {
					if (
						response?.action === 'auth' &&
						response?.result === 'OK'
					) {
						localStorage.setItem('authtoken', response.authToken);
						window.top.location.href = `/my-tests`;
						return true;
					}

					this.setState({
						pinError: true,
						pinMessage: 'Unbekannter Fehler.',
					});
				})
				.catch((err) => {
					let pinMessage = 'Ein Fehler ist aufgetreten.';
					if (
						err?.status === 401 &&
						/Invalid regId or pin/i.test(err.error)
					) {
						pinMessage = 'Falscher PIN. Bitte erneut versuchen.';
					} else if (err?.status === 404) {
						pinMessage = err.error;
						this.setState({emailError: true, pinMessage});
						return false;
					} else if (err?.status === 410) {
						pinMessage = 'Bestätigungslink ist abgelaufen.';
					} else if (typeof err?.error === 'string') {
						pinMessage = err.error;
					}

					this.setState({pswError: true, pinMessage});
					return false;
				})
				.finally(() => this.setState({loading: false}));
		}

		if (!testKey && resetFlag) {
			resetPassword(resetFlag, this.state.testAdmin.psw).then((res) => {
				this.setState({loading: false});

				if (res?.error) {
					this.setState({
						showAlert: true,
						error: true,
						message: res.error,
					});
					this.alertTimeout = setTimeout(
						() => this.setState({showAlert: false}),
						3000
					);
				}
				if (res?.ok) {
					this.setState({
						flowStatus: strings.passwrodchanged,
						showAlert: true,
						success: true,
						message: 'Das Passwort wurde geändert',
					});
					this.alertTimeout = setTimeout(
						() => this.setState({showAlert: false}),
						3000
					);
					this.redirectTimeout = setTimeout(() => {
						window.top.location.href = `/login`;
					}, 4000);
				} else if (res?.status === 408) {
					this.setState({
						flowStatus: 'link expired',
						linkTimedOut: true,
					});
					this.redirectTimeout = setTimeout(() => {
						window.top.location.href = `/login`;
					}, 4000);
				}
			});
		}
	}

	changeAuthMethodToEmail() {
		if (this.state.regTokenChange) {
			changeMethodCustom(this.state.testAdmin).then((res) => {
				this.setState({loading: false});
				if (!res?.ok && res?.status === 401) {
					console.log('Error:401');
				}
			});
		}
	}

	render() {
		const {
			loading,
			showAlert,
			message,
			isResendButtonDisabled,
			success,
			isTokenValid,
			strengthExhibitor,
			invalidEmail,
			isResetingPsw,
			hasSendVerification,
			flowStatus,
			linkTimedOut,
			hasResetToken,
			regTokenChange,
			isForgetPasswordClicked,
		} = this.state;

		const showEmailField = !testKey && !isResetingPsw && !hasResetToken;

		const canRegisterStrong =
			testKey &&
			!resetFlag &&
			strengthExhibitor === 'lit-strength-Exhibitor-green' &&
			!this.state.unmatchedPassword;
		const canResetStrong =
			!testKey &&
			resetFlag &&
			strengthExhibitor === 'lit-strength-Exhibitor-green' &&
			!this.state.unmatchedPassword &&
			!regTokenChange;
		const canChangeMethodStrong =
			!testKey &&
			!resetFlag &&
			strengthExhibitor === 'lit-strength-Exhibitor-green' &&
			!this.state.unmatchedPassword &&
			!!regTokenChange;

		return (
			<div className="lit-customLogin">
				<div>
					<div className="lit-customLogin__wrapper">
						{isResetingPsw && (
							<div>
								<h4>
									Wir haben einen neuen Link an Ihre
									E-Mail-Adresse gesendet. Folgen Sie dem
									neuen Link, um ein neues Passwort
									zurückzusetzen.
								</h4>
								{isResendButtonDisabled && (
									<span className="lit-btn-link-resend-text">
										Senden Sie den Code in{' '}
										{this.state.resendCountDown} Sekunden
										erneut.
									</span>
								)}
								<div className="lit-btn-link-resend-wrapper">
									<button
										className="lit-btn-link-resend"
										onClick={this.handleResendClick}
										disabled={isResendButtonDisabled}
									>
										{strings.resend}
									</button>
								</div>
							</div>
						)}

						{!hasSendVerification && !isResetingPsw && (
							<>
								<h1 className="lit-customLogin-title">
									{testKey
										? 'Registrieren Sie sich'
										: resetFlag
											? 'Neues Passwort'
											: 'Einloggen'}
								</h1>

								{flowStatus && !resetFlag && (
									<div className="lit-reset-info-container">
										<p className="lit-reset-info">
											{strings.resetpswlinksent}
										</p>
									</div>
								)}

								{flowStatus && linkTimedOut && (
									<div className="lit-invlaid-status-container">
										<p className="lit-invlaid-note">
											{'Link expired'}
										</p>
									</div>
								)}

								{isTokenValid && (
									<div className="lit-screen__content">
										<form
											className="customregister-form-login"
											onSubmit={(event) => {
												event.preventDefault();
												this.setState({loading: true});
												if (isForgetPasswordClicked) {
													this.sendResetLink(
														this.state.testAdmin
															.email
													);
												} else if (canRegisterStrong) {
													this.addAdminViaCustomMethod(
														testKey
													);
												} else if (
													!testKey &&
													!regTokenChange &&
													!resetFlag
												) {
													this.allowOperation(); // login
												} else if (canResetStrong) {
													this.allowOperation(); // reset
												} else if (
													canChangeMethodStrong
												) {
													this.changeAuthMethodToEmail();
												} else {
													// If nothing matched, stop loading
													this.setState({
														loading: false,
													});
												}
											}}
										>
											<div className="lit-customLogin-form-wrapper">
												{testKey && (
													<div className="lit-compound-fields">
														<label className="lit-label lit-label-usr">
															{strings.firstname}

															<Input
																required
																name="firstName"
																id="user-firstName"
																disableUnderline
																className="customLogin-user-tf"
																type="text"
																onChange={
																	this
																		.handleUpdateTestAdminEvent
																}
																onInvalid={
																	this
																		.setRequiredMsg
																}
																onInput={
																	this
																		.clearValidity
																}
																startAdornment={
																	<InputAdornment position="start">
																		<FontAwesomeIcon
																			className="field-icon"
																			icon={
																				faUser
																			}
																		/>
																	</InputAdornment>
																}
															/>
														</label>

														<div className="lit-label lit-label-psw">
															<label>
																{
																	strings.lastname
																}

																<Input
																	required
																	disableUnderline
																	name="lastName"
																	id="user-lastName"
																	className="customLogin-psw-tf"
																	onChange={
																		this
																			.handleUpdateTestAdminEvent
																	}
																	onInvalid={
																		this
																			.setRequiredMsg
																	}
																	onInput={
																		this
																			.clearValidity
																	}
																	type="text"
																	startAdornment={
																		<InputAdornment position="start">
																			<FontAwesomeIcon
																				className="field-icon"
																				icon={
																					faUser
																				}
																			/>
																		</InputAdornment>
																	}
																/>
															</label>
														</div>

														<div className="lit-label lit-label-usr">
															<label className="customLogin-user-lbl">
																{
																	strings.telephone
																}

																<Input
																	name="phone"
																	id="user-telephone"
																	type="tel"
																	value={
																		this
																			.state
																			.phone ||
																		''
																	}
																	onBeforeInput={
																		this
																			.handlePhoneBeforeInput
																	}
																	onPaste={
																		this
																			.handlePhonePaste
																	}
																	onChange={
																		this
																			.handlePhoneChange
																	}
																	inputMode="numeric"
																	inputProps={{
																		maxLength: 11,
																	}}
																	disableUnderline
																	className="customLogin-user-tf"
																	startAdornment={
																		<InputAdornment position="start">
																			<FontAwesomeIcon
																				className="field-icon"
																				icon={
																					faPhone
																				}
																			/>
																		</InputAdornment>
																	}
																/>
															</label>
														</div>
													</div>
												)}

												<div className="lit-compound-fields">
													{showEmailField && (
														<div>
															<i className="lit-login__icon fas fa-lock"></i>
															<label className="lit-label lit-label-usr">
																{strings.email}
																<Input
																	required
																	name="email"
																	id="user-email"
																	disableUnderline
																	className="customLogin-user-tf"
																	type="email"
																	onChange={
																		this
																			.validateEmail
																	}
																	onBlur={() =>
																		this.setState(
																			{
																				emailTouched: true,
																			}
																		)
																	}
																	onInvalid={
																		this
																			.setEmailMsg
																	}
																	onInput={
																		this
																			.clearValidity
																	}
																	startAdornment={
																		<InputAdornment position="start">
																			<FontAwesomeIcon
																				className="field-icon"
																				icon={
																					faUser
																				}
																			/>
																		</InputAdornment>
																	}
																/>
															</label>
															{this.state
																.emailTouched &&
																this.state
																	.invalidEmail && (
																	<div className="lit-invlaid-email-note-container">
																		<p className="lit-invalid-email-note">
																			Die
																			E-Mail-Adresse
																			ist
																			ungültig.
																			Bitte
																			geben
																			Sie
																			eine
																			gültige
																			E-Mail-Adresse
																			ein.
																		</p>
																	</div>
																)}
														</div>
													)}

													{!testKey &&
														!isResetingPsw &&
														hasResetToken &&
														isTokenValid && (
															<div>
																<label className="lit-label lit-label-psw">
																	{
																		'Neues Passwort'
																	}

																	<Input
																		required
																		name="psw"
																		id="user-psw"
																		disableUnderline
																		className="customLogin-psw-tf"
																		type={
																			this
																				.state
																				.showPassword
																				? 'text'
																				: 'password'
																		}
																		pattern="(?=.*[A-Z])(?=.*\\d)(?=.*[\\W_]).{8,}"
																		onChange={
																			this
																				.validatePassword
																		}
																		onInvalid={
																			this
																				.setPasswordPatternMsg
																		}
																		onInput={
																			this
																				.clearValidity
																		}
																		title="Mindestens 8 Zeichen mit 1 Großbuchstaben, 1 Zahl und 1 Sonderzeichen."
																		startAdornment={
																			<InputAdornment position="start">
																				<FontAwesomeIcon
																					className="field-icon"
																					icon={
																						faLock
																					}
																				/>
																			</InputAdornment>
																		}
																		endAdornment={
																			<InputAdornment position="end">
																				<IconButton
																					onClick={
																						this
																							.handleClickShowPassword
																					}
																				>
																					{this
																						.state
																						.showPassword ? (
																						<Visibility />
																					) : (
																						<VisibilityOff />
																					)}
																				</IconButton>
																			</InputAdornment>
																		}
																	/>
																</label>
																<ul
																	className="pw-checklist"
																	aria-live="polite"
																>
																	<li
																		className={
																			this
																				.state
																				.passwordChecks
																				.length
																				? 'ok'
																				: 'bad'
																		}
																	>
																		{this
																			.state
																			.passwordChecks
																			.length
																			? '✔︎'
																			: '✖︎'}{' '}
																		Mindestens
																		8
																		Zeichen
																	</li>
																	<li
																		className={
																			this
																				.state
																				.passwordChecks
																				.upper
																				? 'ok'
																				: 'bad'
																		}
																	>
																		{this
																			.state
																			.passwordChecks
																			.upper
																			? '✔︎'
																			: '✖︎'}{' '}
																		Mindestens
																		1
																		Großbuchstabe
																		(A–Z)
																	</li>
																	<li
																		className={
																			this
																				.state
																				.passwordChecks
																				.digit
																				? 'ok'
																				: 'bad'
																		}
																	>
																		{this
																			.state
																			.passwordChecks
																			.digit
																			? '✔︎'
																			: '✖︎'}{' '}
																		Mindestens
																		1 Zahl
																		(0–9)
																	</li>
																	<li
																		className={
																			this
																				.state
																				.passwordChecks
																				.special
																				? 'ok'
																				: 'bad'
																		}
																	>
																		{this
																			.state
																			.passwordChecks
																			.special
																			? '✔︎'
																			: '✖︎'}{' '}
																		Mindestens
																		1
																		Sonderzeichen
																		(!@#$…)
																	</li>
																</ul>
															</div>
														)}

													{!testKey &&
														!isResetingPsw &&
														hasResetToken &&
														isTokenValid && (
															<div className="lit-label lit-label-psw">
																<label className="lit-label lit-label-psw">
																	{
																		strings.confirmpassword
																	}

																	<Input
																		required
																		name="confirm-psw"
																		id="txtConfirmPassword"
																		disableUnderline
																		className="customLogin-psw-tf"
																		type="password"
																		onChange={
																			this
																				.validateConfirm
																		}
																		onInvalid={
																			this
																				.setPasswordMatchMsg
																		}
																		onInput={
																			this
																				.clearValidity
																		}
																		title="Bestätigen Sie Ihr Passwort."
																		startAdornment={
																			<InputAdornment position="start">
																				<FontAwesomeIcon
																					className="field-icon"
																					icon={
																						faLock
																					}
																				/>
																			</InputAdornment>
																		}
																	/>
																</label>
															</div>
														)}

													{(testKey ||
														regTokenChange) && (
														<div>
															<label className="lit-label lit-label-usr">
																{
																	strings.password
																}

																<Input
																	required
																	name="psw"
																	id="user-psw"
																	disableUnderline
																	className="customLogin-user-tf"
																	type={
																		this
																			.state
																			.showPassword
																			? 'text'
																			: 'password'
																	}
																	pattern="(?=.*[A-Z])(?=.*\\d)(?=.*[\\W_]).{8,}"
																	onChange={
																		this
																			.validatePassword
																	}
																	onInvalid={
																		this
																			.setPasswordPatternMsg
																	}
																	onInput={
																		this
																			.clearValidity
																	}
																	title="Mindestens 8 Zeichen mit 1 Großbuchstaben, 1 Zahl und 1 Sonderzeichen."
																	startAdornment={
																		<InputAdornment position="start">
																			<FontAwesomeIcon
																				className="field-icon"
																				icon={
																					faLock
																				}
																			/>
																		</InputAdornment>
																	}
																	endAdornment={
																		<InputAdornment position="end">
																			<IconButton
																				onClick={
																					this
																						.handleClickShowPassword
																				}
																			>
																				{this
																					.state
																					.showPassword ? (
																					<Visibility />
																				) : (
																					<VisibilityOff />
																				)}
																			</IconButton>
																		</InputAdornment>
																	}
																/>
															</label>
															{(testKey ||
																this.state
																	.hasResetToken ||
																this.state
																	.regTokenChange) && (
																<ul
																	className="pw-checklist"
																	aria-live="polite"
																>
																	<li
																		className={
																			this
																				.state
																				.passwordChecks
																				.length
																				? 'ok'
																				: 'bad'
																		}
																	>
																		{this
																			.state
																			.passwordChecks
																			.length
																			? '✔︎'
																			: '✖︎'}{' '}
																		Mindestens
																		8
																		Zeichen
																	</li>
																	<li
																		className={
																			this
																				.state
																				.passwordChecks
																				.upper
																				? 'ok'
																				: 'bad'
																		}
																	>
																		{this
																			.state
																			.passwordChecks
																			.upper
																			? '✔︎'
																			: '✖︎'}{' '}
																		Mindestens
																		1
																		Großbuchstabe
																		(A–Z)
																	</li>
																	<li
																		className={
																			this
																				.state
																				.passwordChecks
																				.digit
																				? 'ok'
																				: 'bad'
																		}
																	>
																		{this
																			.state
																			.passwordChecks
																			.digit
																			? '✔︎'
																			: '✖︎'}{' '}
																		Mindestens
																		1 Zahl
																		(0–9)
																	</li>
																	<li
																		className={
																			this
																				.state
																				.passwordChecks
																				.special
																				? 'ok'
																				: 'bad'
																		}
																	>
																		{this
																			.state
																			.passwordChecks
																			.special
																			? '✔︎'
																			: '✖︎'}{' '}
																		Mindestens
																		1
																		Sonderzeichen
																		(!@#$…)
																	</li>
																</ul>
															)}
														</div>
													)}

													{!testKey &&
														!isResetingPsw &&
														!hasResetToken &&
														!regTokenChange &&
														!isForgetPasswordClicked && (
															<label className="lit-label lit-label-psw">
																{
																	strings.password
																}

																<Input
																	required
																	name="psw"
																	id="user-psw"
																	disableUnderline
																	className="customLogin-psw-tf"
																	type={
																		this
																			.state
																			.showPassword
																			? 'text'
																			: 'password'
																	}
																	pattern="(?=.*[A-Z])(?=.*\\d)(?=.*[\\W_]).{8,}"
																	onChange={
																		this
																			.validatePassword
																	}
																	onInvalid={
																		this
																			.setPasswordPatternMsg
																	}
																	onInput={
																		this
																			.clearValidity
																	}
																	startAdornment={
																		<InputAdornment position="start">
																			<FontAwesomeIcon
																				className="field-icon"
																				icon={
																					faLock
																				}
																			/>
																		</InputAdornment>
																	}
																	endAdornment={
																		<InputAdornment
																			position="end"
																			disablePointerEvents={
																				false
																			}
																			style={{
																				borderBottom:
																					'none',
																			}}
																		>
																			<IconButton
																				onClick={
																					this
																						.handleClickShowPassword
																				}
																			>
																				{this
																					.state
																					.showPassword ? (
																					<Visibility />
																				) : (
																					<VisibilityOff />
																				)}
																			</IconButton>
																		</InputAdornment>
																	}
																/>
															</label>
														)}

													{(testKey ||
														regTokenChange) && (
														<div className="">
															<label className="lit-label lit-label-psw">
																{
																	strings.confirmpassword
																}

																<Input
																	required
																	name="confirm-psw"
																	id="txtConfirmPassword"
																	disableUnderline
																	className="customLogin-psw-tf"
																	type="password"
																	onChange={
																		this
																			.validateConfirm
																	}
																	onInvalid={
																		this
																			.setPasswordMatchMsg
																	}
																	onInput={
																		this
																			.clearValidity
																	}
																	title="Bestätigen Sie Ihr Passwort."
																	startAdornment={
																		<InputAdornment position="start">
																			<FontAwesomeIcon
																				className="field-icon"
																				icon={
																					faLock
																				}
																			/>
																		</InputAdornment>
																	}
																/>
															</label>
														</div>
													)}
												</div>
											</div>

											{flowStatus &&
												!linkTimedOut &&
												resetFlag && (
													<div className="lit-valid-change-container">
														<p className="lit-valid-change">
															{flowStatus}
														</p>
													</div>
												)}

											{!isResetingPsw && (
												<div>
													{this.state.pswError && (
														<div className="psw-error">
															<FontAwesomeIcon
																icon={
																	faExclamationCircle
																}
																className="error-icon"
															/>
															{
																'Ungültige Passwort.'
															}
														</div>
													)}
													{this.state.emailError && (
														<div className="psw-error">
															<FontAwesomeIcon
																icon={
																	faExclamationCircle
																}
																className="error-icon"
															/>
															{
																'Ungültige E-Mail.'
															}
														</div>
													)}
													<div className="lit-btn-submit-wrapper">
														<button
															className="cta-btn"
															disabled={loading}
														>
															{testKey
																? 'Registrieren'
																: resetFlag
																	? 'Erstellen'
																	: isForgetPasswordClicked
																		? 'Senden'
																		: 'Einloggen'}
															{loading ? (
																<div className="spinner"></div>
															) : (
																<FontAwesomeIcon
																	className="lit-signin__icon"
																	icon={
																		faSignIn
																	}
																/>
															)}
														</button>
													</div>
												</div>
											)}

											{!resetFlag && (
												<div className="lit-reset-psw-container">
													<a
														className="lit-reset-psw"
														onClick={() =>
															this.setState({
																isForgetPasswordClicked: true,
															})
														}
													>
														Passwort vergessen?
													</a>
												</div>
											)}
											<div className="lit-login__new-user-wrapper">
												<a
													className="lit-login__new-user-link"
													href="/enrollment"
												>
													{
														'Neue:r Nutzer:in? Registrieren Sie sich hier.'
													}
												</a>
											</div>
										</form>
									</div>
								)}
							</>
						)}

						{hasSendVerification && (
							//<div className="lit-customLogin-wrapper">
							<div className="pin-card">
								<header className="pin-card__header">
									<h1 className="pin-card__title">
										{testKey
											? 'Registrieren Sie sich'
											: 'Einloggen'}
									</h1>
									<p className="pin-card__subtitle">
										{' '}
										Bitte füllen Sie dieses Feld aus
									</p>
								</header>
								{this.state.success && (
									<div
										className="pin-banner pin-banner--success"
										role="status"
										aria-live="polite"
									>
										PIN akzeptiert – Weiterleitung …
									</div>
								)}
								{/* <br /> */}
								<form
									className="pin-card__form"
									onSubmit={(event) => {
										event.preventDefault();
										if (
											!(
												this.state.testAdmin.pin || ''
											).match(
												new RegExp(
													`^[A-Za-z0-9]{${PIN_LEN}}$`
												)
											)
										) {
											this.setState({loading: false});
											// TODO: maybe show a friendly message here
											return;
										}
										this.setState({
											loading: true,
											success: false,
										});
										this.verifyAdminRegistration(testKey);
									}}
								>
									<label className="pin-field__label">
										<span className="pin-field__labelText">
											PIN
										</span>
										<div className="pin-field__segmented">
											<PinCode
												length={6}
												value={
													this.state.testAdmin.pin ||
													''
												}
												onChange={(v) =>
													this.handleUpdate('pin', v)
												}
												onComplete={(v) => {
													// for autoSubmission
												}}
												status={
													this.state.pinError
														? 'error'
														: this.state.success
															? 'success'
															: undefined
												}
												shakeKey={
													this.state.pinError &&
													String(Date.now())
												}
											/>
											{this.state.pinError && (
												<div className="pin-error">
													<FontAwesomeIcon
														icon={
															faExclamationCircle
														}
														className="error-icon"
													/>
													{
														'Ungültige PIN. Bitte erneut versuchen.'
													}
												</div>
											)}

											{!this.state.pinError && (
												<div className="pin-helper">
													Bitte geben Sie Ihre
													6-stellige PIN ein (A–Z,
													0–9).
												</div>
											)}
										</div>
									</label>

									<div className="pin-actions">
										<button
											className="cta-btn"
											disabled={this.state.loading}
										>
											{strings.send}
											{this.state.loading ? (
												<div className="spinner" />
											) : null}
										</button>
									</div>
								</form>
							</div>
						)}

						{showAlert && (
							<AlertBox
								type={success ? 'success' : 'error'}
								message={message}
							/>
						)}

						<div className="lit-log-gram-wrapper">
							<img
								className="lit-fav-logo__img"
								src={Logo}
								alt="Literate logo"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default EmailPasswordLogin;
